export const OK = 200;
export const CREATED = 201;
export const BAD_REQUEST = 400;
export const NO_CONTENT = 204;
export const INTERNAL_SERVER_ERROR = 500;
export const MINIMUM_STATUS_CODE = 199; // Do not use directly. Use isSuccessStatus from requestResponseValidator utility instead.
export const MAXIMUM_STATUS_CODE = 300; // Do not use directly. Use isSuccessStatus from requestResponseValidator utility instead.
export const UNAUTHORIZED = 401;

export const SERVER_LOCKED = 423;
